import * as React from 'react';
import { isNil } from 'lodash';

import DiscoveryCreatorsStateHandler from '../DiscoveryCreatorsStateHandler';
import DiscoveryCreatorsFiltersGeneral from './general/DiscoveryCreatorsFiltersGeneral';
import DiscoveryCreatorsFiltersInstagram from './instagram/DiscoveryCreatorsFiltersInstagram';
import DiscoveryCreatorsFiltersTikTok from './tiktok/DiscoveryCreatorsFiltersTikTok';
import DiscoveryCreatorsFiltersTikTokAudience from './tiktok-audience/DiscoveryCreatorsFiltersTikTokAudience';
import DiscoveryCreatorsFiltersYoutube from './youtube/DiscoveryCreatorsFiltersYoutube';
import DiscoveryCreatorsFiltersInstagramAudience from './instagram-audience/DiscoveryCreatorsFiltersInstagramAudience';
import DiscoveryCreatorsFiltersCreatorDetails from './creator-details/DiscoveryCreatorsFiltersCreatorDetails';
import DiscoveryCreatorsFiltersContent from './content/DiscoveryCreatorsFiltersContent';
import DiscoveryCreatorsFiltersAddLightweight from './lightweight/DiscoveryCreatorsFiltersAddLightweight';

import './discovery-creators-filters.scss';

import type { DiscoveryCreatorsFilters as DiscoveryCreatorsFiltersType } from 'types';

type Props = {
  filters: DiscoveryCreatorsFiltersType,
  isFreemium: boolean
};

class DiscoveryCreatorsFilters extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { filters, isFreemium } = this.props;
    const channels = filters.channels;
    const instagram = channels.find(item => item.identifier === 'instagram' && item.selected);
    const youtube = channels.find(item => item.identifier === 'youtube' && item.selected);
    const tiktok = channels.find(item => item.identifier === 'tiktok' && item.selected);

    // separate checks are needed for !isNil(instagram) (below) b/c the state
    // handler renders its children and it sees <React.Fragment> as a child
    return (
      <div className="discovery-creators-filters">
        <DiscoveryCreatorsStateHandler>
          <DiscoveryCreatorsFiltersGeneral
            isFreemium={isFreemium}
          />
          {
            !isNil(instagram) && (
              <DiscoveryCreatorsFiltersInstagram />
            )
          }
          {
            !isNil(instagram) && (
              <DiscoveryCreatorsFiltersInstagramAudience />
            )
          }
          {
            !isNil(tiktok) && (
              <DiscoveryCreatorsFiltersTikTok />
            )
          }
          {
            !isNil(tiktok) && (
              <DiscoveryCreatorsFiltersTikTokAudience />
            )
          }
          {
            !isNil(youtube) && (
              <DiscoveryCreatorsFiltersYoutube />
            )
          }
          <DiscoveryCreatorsFiltersCreatorDetails
            isFreemium={isFreemium}
          />
          {/* @ts-ignore - TS is confused. It thinks this component needs `lastStateReset` prop but none of other do */}
          <DiscoveryCreatorsFiltersContent
            isFreemium={isFreemium}
          />
          {/* @ts-ignore - TS is confused. It thinks this component needs `channel` prop but none of other do */}
          <DiscoveryCreatorsFiltersAddLightweight
            isFreemium={isFreemium}
          />
        </DiscoveryCreatorsStateHandler>
      </div>
    );
  }
}

export default DiscoveryCreatorsFilters;
